import { ActionItemWrapper as GlobalActionItemWrapper } from '@anm/components/ActionsDropdown';
import { Label } from '@anm/components/BetaLabel';
import TooltipWrapper, { TooltipContent } from '@anm/components/Tooltip/Wrapper';
import { flexCenter } from '@anm/styles/helpers';
import styled from 'styled-components';

export const ActionItemWrapper = styled.div`
  width: 100%;
  ${flexCenter};
  &:hover {
    background-color: rgba(32, 171, 210, 0.1);
  }
`;

export const ActionTooltipWrapper = styled.div`
  width: 100%;
  ${TooltipContent} {
    max-width: 100%;
    line-height: 24px;
  }
  ${TooltipWrapper} {
    width: 100%;
  }
`;

export const ActionTooltip = styled.div`
  min-width: 205px;
  p {
    margin: 0;
  }
  && a {
    padding: 0;
    opacity: 1;
    display: inline;
    color: var(--blue_100);
    min-height: unset;
    line-height: inherit;
    &:hover {
      text-decoration: underline;
      background-color: transparent;
    }
  }
`;

export const RelativeWrapper = styled(GlobalActionItemWrapper)`
  width: 100%;
  position: relative;

  && > a,
  && span {
    padding-left: 48px;
  }

  && ${Label} {
    top: 10px;
    right: 14px;
  }
`;

export const ItemWrapper = styled.div`
  width: inherit;
`;
